import { render, staticRenderFns } from "./popwindowText.vue?vue&type=template&id=8c490ef0"
import script from "./popwindowText.vue?vue&type=script&lang=js"
export * from "./popwindowText.vue?vue&type=script&lang=js"
import style0 from "./popwindowText.vue?vue&type=style&index=0&id=8c490ef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports